import { ProductFormValues } from './types';

export const PRODUCT_TAGS = [
    'ฟิตติ้งAN3/เบรก',
    'ฟิตติ้งAN6-20 HYB',
    'เซ็ตสุดคุ้ม',
    'ท่อยาง/สายถัก',
    'ระบบน้ำมัน',
    'ขายดีประจำเดือน',
    'สินค้าใหม่/PREMIUM LINE',
    'สินค้าลดแรง',
    'สินค้าแนะนำ',
] as const;

export const defaultFormValues: ProductFormValues = {
    name: '',
    description: '',
    price: 0,
    salePrice: null,
    isOnSale: false,
    categoryId: '',
    tags: [],
    soldCount: 0,
    images: [],
    warehouse: 'HYB',
    variants: [],
};

export const resolveProductImage = (
    image: any | undefined,
    preferredSize: 'thumbnail' | 'medium' | 'large' = 'thumbnail',
): string => {
    if (!image) {
        return '';
    }

    if (typeof image === 'string') {
        return image;
    }

    return image[preferredSize] ?? image.large ?? image.medium ?? image.thumbnail ?? '';
};
